export default "https://assets-v2.scaler.com/packs/images/suitcase.1a890b.svg";